import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static values = { uploadingMessage: String }

  connect() {
    this.alertCloseId = null;
    this.onBefore = this.onBefore.bind(this);
    this.onComplete = this.onComplete.bind(this);
    $(this.element).on('ajax:before', this.onBefore);
    $(this.element).on('ajax:complete', this.onComplete);
  }

  disconnect() {
    $(this.element).off('ajax:before', this.onBefore);
    $(this.element).off('ajax:complete', this.onComplete);
  }

  onBefore() {
    if (!this.uploadingMessageValue) { return; }

    alertCustom(this.uploadingMessageValue, { alertType: 'info', displayPlacement: 'hover', icon: 'loading' });
    this.alertCloseId = $('#js-flash-messages-hover .js-close-flash').last().attr('id');
  }

  onComplete() {
    if (!this.alertCloseId) { return; }

    $(`#${this.alertCloseId}`).click();
    this.alertCloseId = null;
  }
}
